import React from 'react';

const destinations = [
    {
        country: 'Indonesia - Yogyakarta',
        flag: '🇮🇩',
        image: '../image/trending/Borobudur.png',
    },
    {
        country: 'Japan - Tokyo',
        flag: '🇯🇵',
        image: '../image/trending/Tokyo.png',
    },
    {
        country: 'Indonesia - Bali',
        flag: '🇮🇩',
        image: '../image/trending/Bali.png',
    },
    {
        country: 'Korea',
        flag: '🇰🇷',
        image: '../image/trending/Korea.png',
    },
    {
        country: 'Singapore',
        flag: '🇸🇬',
        image: '../image/trending/Singapore.png',
    },
];


export default function TrendingDestinations() {
    return (
        <section className="px-6 py-10 max-w-7xl mx-auto">
            <h2 className="text-xl font-semibold flex items-center gap-2 mb-6">
                <span>🌐</span> Trending Destinations
            </h2>

            {/* Baris Pertama: 2 Kolom */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                {destinations.slice(0, 2).map((item, idx) => (
                    <div
                        key={idx}
                        className="rounded-xl overflow-hidden shadow-md relative h-60 bg-cover bg-center"
                        style={{ backgroundImage: `url(${item.image})` }}
                    >
                        <div className="absolute inset-0 bg-black bg-opacity-30 flex items-start justify-start p-4">
                            <div className="text-white font-bold text-lg">
                                <span className="text-2xl mr-2">{item.flag}</span>
                                {item.country}
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {/* Baris Kedua: 3 Kolom */}
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                {destinations.slice(2).map((item, idx) => (
                    <div
                        key={idx}
                        className="rounded-xl overflow-hidden shadow-md relative h-60 bg-cover bg-center"
                        style={{ backgroundImage: `url(${item.image})` }}
                    >
                        <div className="absolute inset-0 bg-black bg-opacity-30 flex items-start justify-start p-4">
                            <div className="text-white font-bold text-lg">
                                <span className="text-2xl mr-2">{item.flag}</span>
                                {item.country}
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            <div className="mt-8 flex justify-center">
                <button className="bg-sky-100 text-sky-600 font-semibold py-2 px-4 rounded-lg shadow-md hover:bg-sky-200 transition">
                    See All Destinations
                </button>
            </div>
        </section>
    );
}
